export const messages = {
  en: {
    listRoomRenovationRecordDetails: {
      title: 'Renovation Record',
      back: 'Back',
      room: 'Room',
      media: 'Media',
      originalMedia: 'Original Media',
      createTime: 'Create Time',
      fetchError: 'Failed to fetch renovation record details'
    }
  },
  zh: {
    listRoomRenovationRecordDetails: {
      title: '装修记录',
      back: '返回',
      room: '房屋',
      media: '图片/视频',
      originalMedia: '原始图片/视频',
      createTime: '创建时间',
      fetchError: '获取装修记录详情失败'
    }
  }
}